
import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

@Component({
    imports: [],
    selector: 'app-input-error',
    templateUrl: './input-error.component.html',
    styleUrls: ['./input-error.component.css'],
    standalone: true
})
export class InputErrorComponent implements OnInit {

    @Input()
    control!: UntypedFormControl;

    @Input()
    submitted: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
    }

}
